import React from 'react';
import { useFetch } from '@/hooks';
import style from './style.module.scss';
import Link from 'next/link';
import Image from 'next/image';
import { Article } from '@/types/analitics';
import { MainNews, NoImage } from '..';
import notImagePoster from '../../public/not-image.png';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);


export const LastNews = async () => {
  const { data } = await useFetch(process.env.NEXT_PUBLIC_API_URL + '/analitikas?populate=*&sort[createdAt]=desc');

  if (!data) {
    return 'Ошибка';
  }
  return (
    <div className={style.news}>
      <div className={style.content}>
        <MainNews/>
        <div className={style.right}>
          {data?.slice(0, 5).map((elem: Article) => {
            return (
              <Link key={elem?.id} href={`/analitics/${elem?.id}`} className={style.element}>
                <h3 className={style.title}>
                  {elem?.title.length > 100 ? `${elem?.title.slice(0, 100)}...` : elem?.title}
                </h3>
                <p className={style.date}>
                  <span>{dayjs(elem.date ?? elem.createdAt).format('DD.MM')}</span>
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};
